pageId = 'page-project-settings'
page = '#' + pageId

$ ->

  $('body').on 'ajax:beforeSend', page + ' #btn-archive-project', (e) ->
    simple.loading
      type: 'global'
      msg: '正在归档项目...'

    simple.stack.clearCache()

  .on 'ajax:beforeSend', "#{ page } #btn-unarchive-project", (e) ->
    simple.loading
      type: 'global'
      msg: '正在激活项目...'

    simple.stack.clearCache()

  .on 'ajax:success', "#{ page } #btn-archive-project", (e) ->
    simple.loading.destroy()
    tower.guideSubject.next('project_archive', {})

  .on 'ajax:success', "#{ page } #btn-unarchive-project", (e) ->
    simple.loading.destroy()

  .on 'keyup', "#{ page } #del-project-text", (e) ->
    $target = $(e.currentTarget)
    if $target.val() is 'DELETE'
      $('#btn-exec-del').prop 'disabled', false
    else
      $('#btn-exec-del').prop 'disabled', true

  .on 'click', "#{ page } .project-sections .link-toggle", (e) ->
    $section = $(@).closest('.section')
    $sections = $section.parent()

    if $section.hasClass 'disabled'
      $section.prependTo $sections
        .removeClass 'disabled'
    else
      $section.appendTo $sections
        .addClass 'disabled'

    updateSort $section

  .on 'ajax:success', "#{ page } #section-webhooks .link-destroy", (e, result) ->
    if result.success
      $(@).closest('.hook-item').slideUp 'fast', ->
        $(@).remove()

  .on 'click', "#{page} .topics-setting .select", (e) ->
    $select = $(e.currentTarget)
    type = $select.data('type')
    value = $("input[type='hidden'][name='#{type}']").val()

    popover = simple.popover
      pointTo: $select
      content: $($select.data('options-tpl-id')).html()
      position: 'bottom-right'
      cls: 'dropdown-list no-arrow topics-setting-popover'
      autoAdjustPosition: false
      offset:
        x: if type == 'topics_display_count' then 0 else -44
        y: -7

    popover.el.data('topics-setting-type', type)
    popover.el.find(".menu li a[data-value='#{value}'] .twr").addClass('selected')

  .on 'click', ".topics-setting-popover.dropdown-list li a", (e)->
    $target = $(e.currentTarget)
    popover = $target.closest('.topics-setting-popover').data('popover')
    guid = $target.data('guid')
    type = popover.el.data('topics-setting-type')
    value = $target.data('value')

    $('.topics-setting-popover.dropdown-list li a .twr.selected').removeClass('selected')
    $target.find('.twr').addClass('selected')

    $("input[type='hidden'][name='#{type}']").val(value)
    $(".topics-setting .select[data-type='#{type}'] .result").html($target.data('text') || value)

    data =
      sections: JSON.parse($("#{page} #project-sections-order").val())
    data[type] = value

    $.ajax
      url: $("#{page} .project-sections").data('url')
      type: 'post'
      data: data

    popover.destroy()

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  tower.projectBadge target: '.btn-change-project-badge .badge'

  if $page.is('[data-archived], [data-deleted]')
    $page.find('#project-name, #project-desc, #btn-save-settings').attr('disabled', 'disabled')
    $page.find('#section-custom, #section-webhooks').hide()

  if $page.find('#project-sections-order').length
    sortList($page.find('#project-sections-order').val())
    sortSections $page.find('.project-sections')


sortList = (order) ->
  order = JSON.parse(order)
  $sections = $('.project-sections .sections')

  order.forEach (i) ->
    $sections.find(".section[data-section=#{i}]").appendTo $sections

  $sections.find('.section').each ->
    $section = $ @
    if order.indexOf($section.data('section')) == -1
      $section.appendTo($sections).addClass('disabled')


sortSections = ($selector) ->
  $selector.sortable
    axis: 'y'
    items: '.section:not(.disabled)'
    cancel: '.disabled'
    cursor: 'move'
    helper: 'clone'
    placeholder: 'section-placeholder'
    update: (e, ui) ->
      updateSort ui.item


updateSort = ($section) ->
  $sections = $section.closest('.project-sections')
  order = $sections.find('.section').map ->
    $el = $(@)
    $el.data('section') unless $el.hasClass('disabled')
  .get()

  $('#project-sections-order').val("[#{order}]")

  if $sections.data('url')
    $.ajax
      url: $sections.data('url')
      type: 'post'
      data:
        sections: order
      success: ->
        tower.highlight $section
